var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityIconClicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.625C6.75 3.20875 8.70875 1.25 11.125 1.25C13.5412 1.25 15.5 3.20875 15.5 5.625C15.5 8.04125 13.5412 10 11.125 10C8.70875 10 6.75 8.04125 6.75 5.625Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.625C6.75 3.20875 8.70875 1.25 11.125 1.25C13.5412 1.25 15.5 3.20875 15.5 5.625C15.5 8.04125 13.5412 10 11.125 10C8.70875 10 6.75 8.04125 6.75 5.625Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04672 8.04707C4.93068 9.26931 4.25 10.8959 4.25 12.6814V20H18V12.6814C18 10.8959 17.3193 9.26932 16.2033 8.04707C15.2982 9.94135 13.3644 11.25 11.125 11.25C8.88558 11.25 6.95181 9.94135 6.04672 8.04707Z",
    fill: "#6A84C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04672 8.04707C4.93068 9.26931 4.25 10.8959 4.25 12.6814V20H18V12.6814C18 10.8959 17.3193 9.26932 16.2033 8.04707C15.2982 9.94135 13.3644 11.25 11.125 11.25C8.88558 11.25 6.95181 9.94135 6.04672 8.04707Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIconClicked);
export default __webpack_public_path__ + "static/media/community-icon-clicked.8d09093743f7f7102aac0f7371f242b9.svg";
export { ForwardRef as ReactComponent };